module.exports = __webpack_public_path__ + "img/cyzhao-icon.dca8a5ff.png";